<template>
	<div class="">
		<vm-header ref="dudu"></vm-header>
		<div class="beijngsd">
			<span></span>
			个人中心
			<span></span>
		</div>
		<div class="manpin">
			<div class="main centen container">
				<div class="main_l">
					<div class="topxiang">
						<img src="../../assets/gerenzhongxin/geren19.png">
						<span>用户名用户名用户名</span>
					</div>
					<div class="jibenxinxi">
						<figure v-for="(item,index) in jibenxinxis" @click="getindex(index) "
							:class="{beijngsdtu:index == 5}" >
							<img :src="item.img">
							<figcaption :class="{texts:index == 5}">{{item.text}}</figcaption>
							<div class="xiaoxi" v-show="item.xins">
								{{item.xinshu}}
							</div>
						</figure>
					</div>
				</div>
				<!-- 在class为main_r里面写页面就行 -->
				<div class="main_r" >
					<div class="mainr_top">
						<img src="../images/geren16.png">性格测评
					</div>			
					
					<!--性格评测-->
					<div class="xinggeResult">
						<div class="flex-between">
							<div class="flex-items">
								<div class="txt">学生姓名：<span>hns</span></div>
								<div class="txt">用时：<span>59:00分</span></div>
							</div>
							<time>测评时间：2021.12.06 09:11:12</time>					
						</div>
						<dl class="flex">
							<dt>测评结果：</dt>
							<dd class="flex-1">有创造力,乐于创造新颖、与众不同的成果,渴望表现自己的个性,实现自身的价值,做事理想化,追求完美,不重实际,具有一定的艺术才能和个性。善于表达、怀旧心态较为复张</dd>
						</dl>				
					</div>	
					<div class="xinggeWrap">
						<div class="xinggeWrapItem">
							<div class="xgTItle flex">
								<h4><img src="../images/p4345.png">综合评价</h4>
							</div>
							<p class="text-indent">反应快、睿智,有激励别人的能力,觉性强、直言不讳,在解决新的、具有挑战性时机智而有策略。善于找出理论上的可能性,然后再用战略的眼光分析。善于理解别人,不喜欢例行公事,很少会用相同的方法做相同的事情,倾向于一个接一个的发属新的爱好。</p>
							<p>ENTP型的人喜欢兴奋与挑战,他们热情开放、足智多谋、健谈而明,长于许多事情,不断追求增加能力和个人权力。ENTP型的人天生高有想象力,他们深深地喜欢新思想,留心一切可能性,他们有很强的首创精神,撞于运用创造冲动,ENTP型的人视灵感高于其他的一切,力求使他们的新颖想法转变为现实,他们好子奇、多才多艺、适应性强,在解决挑战性和理论性问题时善于随机应变,ENTP型的人灵活而率直,能够轻易地看出任何情况中的缺点,乐于出于兴争论问题的某方面,他们有极好的分析能力,是出色的第略谋划者。他们几乎一直能够为他们所希望的事情找出符合逻辑的推理大多数的ENTP型人喜欢审视周围的环境,认为多数的规则和章程如果不被打破,使意味着屈从,有时他们的态度不从习俗,乐于帮助别人超出可被接受和被期望的事情。他们喜欢自在地生活,在每天的生活中寻找快乐和变化,ENTP型的人高有想象力地处理社会关系,常常有许多的朋友和熟人,他们表现得很乐观,具有密默感,ENTP型的人吸引和鼓励同伴,通过他们高有感染力的热情,鼓舞别人加入他们的行动中,他们喜欢努力理解和回应他人,而不是判断他人</p>
						</div>
						<div class="xinggeWrapItem">
							<div class="xgTItle flex">
								<h4><img src="../images/p4345.png">专业推荐</h4>
							</div>
							<ul class="xinggeWrapUl">
								<li><a href="">美术学类</a></li>
								<li><a href="">计算机类</a></li>
								<li><a href="">金融类</a></li>
								<li><a href="">海洋工程类</a></li>
								<li><a href="">核工程类</a></li>
								<li><a href="">航空航天类</a></li>
							</ul>
						</div>
					</div>
					<div class="xinggeBtn flex-center">
						<router-link to="./grzx_xinggeceping3" class="ck">查看报告</router-link>
						<router-link to="./kaishicheping" class="pc">再次测评</router-link>
					</div>
					<!--性格评测end-->
				
				</div>
				
				
			</div>
		</div>
		
		
		<item7></item7>
	</div>
</template>

<script>
	import vmHeader from '../../components/vmHeader.vue'
	import item7 from '../../components/item7.vue'
	export default {
		name: "",
		components: {
			vmHeader,
			item7
		},
		data() {
			return {
				jibenxinxis: [{
						img: require("../../assets/gerenzhongxin/geren15.png"),
						text: "基本资料",
						xinshu: "",
						xins: false
					},
					{
						img: require("../../assets/gerenzhongxin/geren14.png"),
						text: "我的分数",
						xins: false,
						xinshu: ""
					},
					{
						img: require("../../assets/gerenzhongxin/geren13.png"),
						text: "我的学生",
						xins: false,
						xinshu: ""
					},
					{
						img: require("../../assets/gerenzhongxin/geren12.png"),
						text: "我的关注",
						xins: true,
						xinshu: "3"
					},
					{
						img: require("../../assets/gerenzhongxin/geren11.png"),
						text: "我的选科",
						xins: false,
						xinshu: ""
					},
					{
						img: require("../../assets/gerenzhongxin/geren10.png"),
						text: "性格测评",
						xinshu: "0",
						xins: false
					},
					{
						img: require("../../assets/gerenzhongxin/geren9.png"),
						text: "收藏院校",
						xins: true,
						xinshu: "3"
					},
					{
						img: require("../../assets/gerenzhongxin/geren8.png"),
						text: "收藏专业",
						xins: true,
						xinshu: "100"
					},
					{
						img: require("../../assets/gerenzhongxin/geren7.png"),
						text: "优化志愿报告单",
						xins: true,
						xinshu: "0"
					},
					{
						img: require("../../assets/gerenzhongxin/geren6.png"),
						text: "修改密码",
						xinshu: "100",
						xins: false
					},
					{
						img: require("../../assets/gerenzhongxin/geren5.png"),
						text: "退出登录",
						xins: false,
						xinshu: ""
					},

				],
				buttonName: "发送短信",
				isDisabled: false,
				time: 60,
				options: [
					{
					  value: '选项1',
					  label: '黄金糕'
					}, {
					  value: '选项2',
					  label: '双皮奶'
					}, {
					  value: '选项3',
					  label: '蚵仔煎'
					}, {
					  value: '选项4',
					  label: '龙须面'
					}, {
					  value: '选项5',
					  label: '北京烤鸭'
					},
				],
				value: '',
				radio: '1',
				radio2:"1",
				duichu:false,
				dusnhhwe:true,
				
				
				// 手机号!/^1[3456789]\d{9}$/.test(this.dinahua)
			}
		},
		
		methods: {
			getindex(index) {
				if (index == 0) {
					this.$router.push('/gerenzhongxin')
				}
				if (index == 1) {
					this.$router.push('/grzx_wdfs')
				}
				if (index == 2) {
					this.$router.push('/grzx_wdxs')
				}
				if (index == 3) {
					this.$router.push('/grzx_wodeguanzhu')
				}
				if (index == 4) {
					this.$router.push('/grzx_wodexuanke')
				}
				if (index == 5) {
					this.$router.push('/grzx_xinggeceping')
				}
				if (index == 6) {
					this.$router.push('/grzx_shouchangxueyuan')
				}
				if (index == 7) {
					this.$router.push('/grzx_chouchangzhuanye')
				}
				if (index == 8) {
					this.$router.push('/grzx_wodezhiyuan')
				}
				if (index == 9) {
					this.$router.push('/grzx_xougaimima')
				}
				if (index == 10) {
					this.$refs.dudu.tuizhu()
				}
			},
			// 取消退出
			quxiao(){
				this.duichu = false
			},
			sendMsg() {
				let me = this;
				me.dusnhhwe = false
				me.isDisabled = true;
				// me.time = 2 ;
				me.buttonName = '<a class="biaoshu">' + 60 + 's</a>' + '<span>后发送</span>' ;
				let interval = window.setInterval(function() {
					
					me.buttonName = '<a class="biaoshu">' + me.time + 's</a>' + '<span>后发送</span>' ;
					--me.time;
					if (me.time < 0) {
						me.buttonName = "重新发送";
						me.dusnhhwe = true
						me.time = 59;
						me.isDisabled = false;
						window.clearInterval(interval);
					}
					
				}, 1000);
			},
			
		}


	}
</script>

<style scoped >
	/* 退出登录 */
	.tuichuden{ width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;position: fixed;top: 0;left: 0;background: rgba(0,0,0,0.8);}
	.annou{display: flex;flex-direction: column;width: 380px;height: 229px;background: rgba(255, 255, 255, 1);opacity: 1;border-radius: 20px;padding: 0 21px;box-sizing: border-box;}
	.annou h1{width: 100%;height: 48px;font-size: 20px;font-family: PingFang SC;font-weight: 500;color: #29A7E1;opacity: 1;display: flex;align-items: center;border-bottom: 1px solid rgba(0, 0, 0, 0.1);}
	.annou p{ width: 100%;display: flex;align-items: center;justify-content: center;font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #666666;flex: 1;}
	.annou dl{width: 100%;display: flex;align-items: center;justify-content: space-between;}
	.annou dl dt{cursor: pointer; width: 140px;height: 46px;background: rgba(200, 200, 200, 1);opacity: 1;border-radius: 23px;font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #666666;display: flex;align-items: center;justify-content: center;}
	.annou dl dd{cursor: pointer;width: 140px;height: 46px;background: linear-gradient(129deg, #F53824 0%, #F44F25 61%, #F45D26 100%);box-shadow: 0px 0px 10px #F53824;opacity: 1;border-radius: 24px;font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #FFFFFF;display: flex;align-items: center;justify-content: center;}
	


	
	.beijngsd {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100px;
		background: url(../../assets/gerenzhongxin/geren21.png)no-repeat;
		background-size: 100% 100%;
		font-size: 28px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
	}

	.beijngsd span {
		display: flex;
		width: 44px;
		height: 2px;
		opacity: 0.48;
		border-radius: 1px;
		background-color: #FFFFFF;
	}

	.beijngsd span:nth-of-type(1) {
		margin-right: 14px;
	}

	.beijngsd span:nth-of-type(2) {
		margin-left: 14px;
	}

	.centen {
		width: 1494px;
		margin: 0 auto;
	}

	.manpin {
		width: 100%;
		height: auto;
		padding: 40px 0;
		box-sizing: border-box;
		background: rgba(251, 251, 251, 1);
	}

	.main {
		padding-bottom: 40px;
		display: flex;
		justify-content: space-between;
	}

	.main_l {
		background: rgba(251, 251, 251, 1);
		width: 290px;
	}

	.topxiang {
		width: 100%;
		height: 194px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background: rgba(255, 255, 255, 1);
		border-radius: 5px;
		margin-bottom: 30px;
	}

	.topxiang img {
		width: 102.73px;
		height: 102.73px;
		margin-bottom: 20px;
	}

	.topxiang span {
		width: 144px;
		height: 22px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
		opacity: 1;
	}

	.jibenxinxi {
		width: 290px;
		height: 700px;
		background: rgba(255, 255, 255, 1);
		opacity: 1;
		border-radius: 5px;
	}

	.jibenxinxi figure {
		width: 100%;
		height: 60px;
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.jibenxinxi figure img {
		height: 44px;
		margin-left: 22px;
	}

	.jibenxinxi figure figcaption {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #666666;
		margin-left: 10px;
	}

	.beijngsdtu {
		background: url(../../assets/gerenzhongxin/geren26.png)no-repeat;
		background-size: 100% 100%;
	}

	.texts {
		color: #F53824 !important;
	}

	.xiaoxi {
		margin-left: 10px;
		background: url(../../assets/gerenzhongxin/geren18.png)no-repeat;
		background-size: 100% 100%;
		width: 33px;
		height: 23px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
	}

	.main_r {
		width: 1190px;
		height: 878px;
		background: rgba(255, 255, 255, 1);
		opacity: 1;
		border-radius: 5px;
		padding: 20px;
		box-sizing: border-box;
	}

	.mainr_top {
		width: 100%;
		height: 68px;
		display: flex;
		align-items: center;
		border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
	}

	.mainr_top img {
		width: 7px;
		height: 24px;
		margin-right: 10px;
	}

	.youxinxi {
		padding: 33px 20px 0 20px;
		width: 310px;
		height: 230px;
		background: rgba(253, 251, 247, 1);
		border: 1px solid #FBF5E9;
		opacity: 1;
		border-radius: 5px;
		position: absolute;
		top: 24px;
		right: 20px;
	}

	.mainr_bot {
		width: 100%;
		position: relative;
	}

	.youxinxi label {
		position: absolute;
		top: -14px;
		left: 20px;
		width: 92px;
		height: 28px;
		background: rgba(244, 166, 65, 1);
		opacity: 1;
		border-radius: 14px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
	}

	.youxinxi figure {
		display: flex;
		margin-bottom: 13px;
	}

	.youxinxi figure img {
		margin-right: 4px;
		width: 18px;
		height: 20px;
	}

	.youxinxi figure figcaption {
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #5A4F40;
	}

	.form {
		width: auto;
		height: auto;
		display: flex;
		flex-direction: column;
		margin-top: 30px;
		margin-left: 40px;
	}

	.form li {
		width: auto;
		display: flex;
		align-items: center;
		margin-bottom: 20px;
		position: relative;
	}

	.form li label {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
		width: 80px;
		text-align: right;
	}

	.form li i {
		color: #F53824;
		margin: 0 5px;
	}

	.form li input {
		width: 372px;
		height: 40px;
		background: rgba(255, 255, 255, 0.39);
		border: 1px solid #E0E0E0;
		opacity: 1;
		border-radius: 5px;
		padding: 0 10px;
		box-sizing: border-box;
		
	}

	.duanxin {
		border: none;
		position: absolute;
		top: 5px;
		left: 240px;
		width: 120px;
		height: 30px;
		background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
		opacity: 1;
		border-radius: 2px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
	}
	.duanxin2{
		border: none;
		position: absolute;
		top: 5px;
		left: 240px;
		width: 120px;
		height: 30px;
		background: rgba(238, 238, 238, 1);
		opacity: 1;
		border-radius: 2px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #999999;
	}
	.shoujiinp{width: auto; display: flex;position: relative;}
	.form li{position: static;}
	/* .form li .shoujiinp input{width: auto;} */
	.form li .shoujiinp span{margin-top: 5px;}

	.form li span {
		margin-left: 5px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #F53824;
		opacity: 1;
	}
	.inps{width: 118px;height: 40px;}
	.inps:nth-of-type(1){margin-right: 9px;}
	.inps:nth-of-type(2){margin-right: 9px;}
	.inpda{width: 372px;height: 40px;background: rgba(255, 255, 255, 0.39);opacity: 1;}
	.baochuan{border: none;margin-left: 115px;margin-top: 20px; width: 140px;height: 46px;background: linear-gradient(92deg, #F53824 0%, #F45D26 100%);opacity: 1;border-radius: 23px;display: flex;align-items: center;justify-content: center;font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #FFFFFF;}

	@media (max-width:1400px) {
		.centen {
			width: auto;
		}
	}
	@media (min-width:750px) {
		.mainr_bot2{display: none;}
	}
	@media (max-width:750px) {
		.mainr_bot{display: none;}
		.beijngsd{height: 70px;font-size: 24px;}
		.main{flex-direction: column;}
		.main_l{width: 100%;}
		.jibenxinxi::-webkit-scrollbar{display: none;}
		.manpin{padding: 20px 0;}
		.topxiang{flex-direction: row;width: 100%;height: auto;justify-content: revert;margin-bottom: 15px;}
		.topxiang span{margin-left: 20px;}
		.topxiang img{margin: 0;height: 60px;width: 60px;}
		.jibenxinxi{width: 100%;height: auto; display: flex; flex-direction: row;overflow-y: hidden;overflow: auto;    background: whitesmoke;}
		.jibenxinxi figure{flex-shrink: 0;width: auto;margin: 0 5px;}
		.beijngsdtu {
			/* background: url(../../assets/gerenzhongxin/sj_geren26.png)no-repeat; */
			background:none;
			/* background-size: 100% 100%; */
			border-bottom: 1px solid #F53824;
		}
		.jibenxinxi figure img{margin-left: 0;}
		
		.youxinxi2 {
			padding: 33px 20px 0 20px;
			width: 100%;
			height: 230px;
			background: rgba(253, 251, 247, 1);
			border: 1px solid #FBF5E9;
			opacity: 1;
			border-radius: 5px;
			position: relative;
		}
		
		.mainr_bot2 {
			width: 100%;
			margin-top: 20px;
			/* position: relative; */
		}
		
		.youxinxi2 label {
			position: absolute;
			top: -14px;
			left: 20px;
			width: 92px;
			height: 28px;
			background: rgba(244, 166, 65, 1);
			opacity: 1;
			border-radius: 14px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 16px;
			font-family: PingFang SC;
			font-weight: 500;
			color: #FFFFFF;
		}
		
		.youxinxi2 figure {
			display: flex;
			margin-bottom: 13px;
		}
		
		.youxinxi2 figure img {
			margin-right: 4px;
			width: 18px;
			height: 20px;
		}
		
		.youxinxi2 figure figcaption {
			font-size: 14px;
			font-family: PingFang SC;
			font-weight: 500;
			color: #5A4F40;
		}
		.main_r{width: 100%;display: flex;flex-direction: column;height: auto;}
		
		
		.form{margin-left: 0;}
		.shoujiinp{flex: 1;display: flex;flex-direction: column;position: relative;}
		.form li{position: static;}
		.form li .shoujiinp input{width: auto;}
		.form li .shoujiinp span{margin-top: 5px;}
		.form li label{flex-shrink: 0;}
		
		.duanxin{right: 10px;left: auto;top: 5px;width: 85px;border-radius:5px ;font-size: 10px;}
		.duanxin2{right: 10px;left: auto;top: 5px;width: 85px;border-radius:5px ;font-size: 10px;}
	}
</style>



// WEBPACK FOOTER //
// src/views/mine/h_wdceping_result2.vue